import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const AccountDeletionPolicy = () => {
  return (
    <>
      <div className="container my-5">
        <div className="card">
          <h2 className="card-header PrivacyPolicyTitle py-3 px-4">
            Account Deletion Policy
          </h2>

          <div className="card-body px-4">
            <p>Account Deletion: You may choose to delete your account on the Platform (i.e. the website <a href="https://123myvpn.com">https://123myvpn.com</a> and/or the mobile application 123MyVPN) and any information associated with it, at any point of time.  Such a request for deletion must be sent in writing to <a href="mailto:123myvpn2024@gmail.com">123myvpn2024@gmail.com</a> or you can login into your account and check for delete account option where you can delete your existing account . In the event that You make a request for deletion of Your account or data, you will no longer be able to access the Platform and/or use the Services, and we reserve the right to not provide You any Services through the Platform. In the event of your request, We may delete Your information (Personal or otherwise) or de-identity it so that it is anonymous and no longer attributable to You. Notwithstanding anything contained in the Privacy Policy, We may retain some or all of Your information in accordance with our policies and/or requirements under applicable law. Terms not defined herein shall have the meaning assigned to them in the Privacy Policy.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountDeletionPolicy;
